import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'ui-swiper',
  imports: [CommonModule],
  templateUrl: './swiper.component.html',
})
export class SwiperComponent implements AfterViewInit {
  readonly swiper = viewChild.required<ElementRef>('swiper');
  readonly showArrow = input(true);

  leftArrow = false;
  rightArrow = true;
  scrollWidth: number;
  clientWidth: number;

  ngAfterViewInit(): void {
    this.scrollWidth = this.swiper().nativeElement.scrollWidth;
    this.clientWidth = this.swiper().nativeElement.clientWidth;
  }

  scrollToLeft() {
    this.leftArrow = this.swiper().nativeElement.scrollLeft > 0;
    const swiper = this.swiper();
    if (this.leftArrow) swiper.nativeElement.scrollLeft -= 240;
    this.rightArrow =
      swiper.nativeElement.scrollLeft + this.clientWidth <
      swiper.nativeElement.scrollWidth;
  }

  scrollToRight() {
    this.rightArrow =
      this.swiper().nativeElement.scrollLeft + this.clientWidth <
      this.swiper().nativeElement.scrollWidth;
    const swiper = this.swiper();
    if (this.rightArrow) swiper.nativeElement.scrollLeft += 240;
    this.leftArrow = swiper.nativeElement.scrollLeft > 0;
  }
}
